"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearlyScheduleHarmonizationManager = void 0;
const moment_1 = __importDefault(require("moment"));
const core_1 = require("../../core");
const constants_1 = require("./constants");
const helpers_1 = require("./helpers");
require("./models");
const MonthlyScheduleHarmonizationManager_1 = require("./MonthlyScheduleHarmonizationManager");
const ScheduleHarmonizationManager_1 = require("./ScheduleHarmonizationManager");
const types_1 = require("./types");
class YearlyScheduleHarmonizationManager extends ScheduleHarmonizationManager_1.ScheduleHarmonizationManager {
    constructor(mainModel, controlModel, models, retentionFieldsSettings) {
        super(models);
        this.mainModel = mainModel;
        this.controlModel = controlModel;
        this.models = models;
        this.retentionFieldsSettings = retentionFieldsSettings;
        this.getDayInMonthData = (month, lastDayLabel) => {
            const days = moment_1.default(`2021 ${month}`, 'YYYY MMMM').daysInMonth();
            return helpers_1.getDayList(days, lastDayLabel);
        };
        this.getFieldMonthOptions = (isArchive) => {
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const monthlyScheduleModelValue = this.models.monthlyScheduleModel.getValue();
            return YearlyScheduleHarmonizationManager.getFieldMonthOptionsData(isArchive, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
        };
        this.getFieldDayNumberInMonthOptions = () => {
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const monthlyScheduleModelValue = this.models.monthlyScheduleModel.getValue();
            return YearlyScheduleHarmonizationManager.getFieldDayNumberInMonthOptionsData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
        };
        this.getFieldTimeOptions = (isArchive) => {
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const monthlyScheduleModelValue = this.models.monthlyScheduleModel.getValue();
            return YearlyScheduleHarmonizationManager.getFieldTimeOptionsData(isArchive, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
        };
        this.getFieldDayOfWeekOptions = (isArchive) => {
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const monthlyScheduleModelValue = this.models.monthlyScheduleModel.getValue();
            return YearlyScheduleHarmonizationManager.getFieldDayOfWeekOptionsData(isArchive, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
        };
        this.isFieldTimeDisabled = () => {
            var _a;
            const modelValue = (_a = this.controlModel) === null || _a === void 0 ? void 0 : _a.getValue();
            const isArchive = (modelValue === null || modelValue === void 0 ? void 0 : modelValue.isArchiveEnabled) || false;
            const fieldTimeOptions = this.getFieldTimeOptions(isArchive);
            return fieldTimeOptions.length === 1;
        };
        this.isFieldDayOfWeekDisabled = () => {
            var _a;
            const modelValue = (_a = this.controlModel) === null || _a === void 0 ? void 0 : _a.getValue();
            const isArchive = (modelValue === null || modelValue === void 0 ? void 0 : modelValue.isArchiveEnabled) || false;
            if ((modelValue === null || modelValue === void 0 ? void 0 : modelValue.fieldDayNumberInMonthValue) === types_1.DAY_NUMBER_IN_MONTH.onDay) {
                return false;
            }
            const fieldDayOfWeekOptions = this.getFieldDayOfWeekOptions(isArchive);
            return fieldDayOfWeekOptions.length === 1;
        };
        this.isArchiveQuarterNotificationVisible = (isArchiveRepositoryExisting) => {
            if (!this.controlModel) {
                return false;
            }
            const controlModelValue = this.controlModel.getValue();
            const isArchiveNotificationShown = controlModelValue.isArchiveEnabled === false && isArchiveRepositoryExisting === true;
            return isArchiveNotificationShown;
        };
        this.getAvailableOptionsData = () => {
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const monthlyScheduleModelValue = this.models.monthlyScheduleModel.getValue();
            return YearlyScheduleHarmonizationManager.getAvailableOptionsData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
        };
        this.shouldArchiveBeEnabled = (currentValue) => {
            if (currentValue === false) {
                return false;
            }
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const dailyThirdRowSchedule = dailyScheduleModelValue.isEnabled
                ? dailyScheduleModelValue.rows.third.schedule.filter(Boolean)
                : [];
            const weeklyThirdRowSchedule = weeklyScheduleModelValue.isEnabled
                ? weeklyScheduleModelValue.rows.third.schedule.filter(Boolean)
                : [];
            return dailyThirdRowSchedule.concat(weeklyThirdRowSchedule).length > 0;
        };
        this.harmonize = (shouldResetSchedule = true) => {
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const monthlyScheduleModelValue = this.models.monthlyScheduleModel.getValue();
            const modelValue = this.mainModel.getValue();
            const isArchiveEnabled = this.shouldArchiveBeEnabled(modelValue.isArchiveEnabled);
            const isReset = shouldResetSchedule && !modelValue.isEnabled && modelValue.isModified;
            // reset
            if (isReset) {
                const initialValue = YearlyScheduleHarmonizationManager.getMainModelInitialValue(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, this.retentionFieldsSettings);
                return Object.assign(Object.assign({}, initialValue), { isArchiveVisible: modelValue.isArchiveVisible });
            }
            const restorePoint = YearlyScheduleHarmonizationManager.getCurrentOrFirstInListItem(modelValue.fields.time, this.getFieldTimeOptions(isArchiveEnabled));
            const dayOfWeek = YearlyScheduleHarmonizationManager.getCurrentOrFirstInListItem(modelValue.fields.dayOfWeek, this.getFieldDayOfWeekOptions(isArchiveEnabled));
            const month = YearlyScheduleHarmonizationManager.getCurrentOrFirstInListItem(modelValue.fields.month, this.getFieldMonthOptions(isArchiveEnabled));
            const dayNumberInMonth = YearlyScheduleHarmonizationManager.getCurrentOrFirstInListItem(modelValue.fields.dayNumberInMonth, this.getFieldDayNumberInMonthOptions());
            return Object.assign(Object.assign({}, modelValue), { isArchiveEnabled, fields: Object.assign(Object.assign({}, modelValue.fields), { time: restorePoint, dayOfWeek,
                    month,
                    dayNumberInMonth }) });
        };
        this.harmonizeControl = () => {
            var _a;
            const modelValue = (_a = this.controlModel) === null || _a === void 0 ? void 0 : _a.getValue();
            const isArchiveEnabled = (modelValue === null || modelValue === void 0 ? void 0 : modelValue.isArchiveEnabled) || false;
            if (!modelValue) {
                throw Error('Control Model does not exists');
            }
            let restorePoint = YearlyScheduleHarmonizationManager.getCurrentOrFirstInListItem(modelValue.fieldTimeValue, this.getFieldTimeOptions(isArchiveEnabled));
            let dayOfWeek = YearlyScheduleHarmonizationManager.getCurrentOrFirstInListItem(modelValue.fieldDayOfWeekValue, this.getFieldDayOfWeekOptions(isArchiveEnabled));
            let month = YearlyScheduleHarmonizationManager.getCurrentOrFirstInListItem(modelValue.fieldMonthValue, this.getFieldMonthOptions(isArchiveEnabled));
            const dayNumberInMonth = YearlyScheduleHarmonizationManager.getCurrentOrFirstInListItem(modelValue.fieldDayNumberInMonthValue, this.getFieldDayNumberInMonthOptions());
            return Object.assign(Object.assign({}, modelValue), { fieldTimeValue: restorePoint, fieldDayOfWeekValue: dayOfWeek, fieldMonthValue: month, fieldDayNumberInMonthValue: dayNumberInMonth });
        };
        this.mainModel = mainModel;
        this.controlModel = controlModel;
        this.models = models;
        this.retentionFieldsSettings = retentionFieldsSettings;
    }
}
exports.YearlyScheduleHarmonizationManager = YearlyScheduleHarmonizationManager;
YearlyScheduleHarmonizationManager.FIELD_COUNT_DEFAULT_VALUE = 1;
YearlyScheduleHarmonizationManager.FIELD_COUNT_MIN_VALUE = constants_1.RETENTION_COUNT_MIN;
YearlyScheduleHarmonizationManager.FIELD_COUNT_MAX_VALUE = constants_1.RETENTION_COUNT_MAX_YEARLY;
YearlyScheduleHarmonizationManager.getMainModelInitialValue = (dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, retentionFieldsSettings) => {
    const dayOfWeekOptions = YearlyScheduleHarmonizationManager.getFieldDayOfWeekOptionsData(false, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
    const timeOptions = YearlyScheduleHarmonizationManager.getFieldTimeOptionsData(false, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
    const monthOptions = YearlyScheduleHarmonizationManager.getFieldMonthOptionsData(false, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
    const dayNumberInMonthOptions = YearlyScheduleHarmonizationManager.getFieldDayNumberInMonthOptionsData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
    const dayOfWeek = dayOfWeekOptions[0] || ScheduleHarmonizationManager_1.ScheduleHarmonizationManager.FIELD_DAY_OF_WEEK;
    const time = timeOptions[0] || ScheduleHarmonizationManager_1.ScheduleHarmonizationManager.FIELD_TIME_INITIAL_VALUE;
    const month = monthOptions[0] || types_1.MONTH_OF_YEAR.january;
    const dayNumberInMonth = dayNumberInMonthOptions[0] || types_1.DAY_NUMBER_IN_MONTH.first;
    return {
        isEnabled: false,
        isModified: false,
        fields: Object.assign(Object.assign({}, YearlyScheduleHarmonizationManager.getWeeklyMonthlyFieldsInitialValue()), { dayOfWeek,
            time,
            month,
            dayNumberInMonth, count: retentionFieldsSettings.fieldCountInitialValue, type: core_1.RETENTION_TYPE.years }),
        isArchiveEnabled: false,
        isArchiveVisible: false,
    };
};
YearlyScheduleHarmonizationManager.getFieldMonthOptionsData = (isArchive, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue) => {
    const availableOptions = YearlyScheduleHarmonizationManager.getAvailableOptionsData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
    return YearlyScheduleHarmonizationManager.getFirstOrThirdRowSchedule(!isArchive, availableOptions.monthOfYear);
};
YearlyScheduleHarmonizationManager.getFieldDayNumberInMonthOptionsData = (dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue) => {
    const availableOptions = YearlyScheduleHarmonizationManager.getAvailableOptionsData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
    // Maksim.Kovalevskii: it doesn't matter which row because in yearly it should be the same list everytime
    return availableOptions.dayNumberInMonth.firstRow;
};
YearlyScheduleHarmonizationManager.getFieldTimeOptionsData = (isArchive, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue) => {
    const availableOptions = YearlyScheduleHarmonizationManager.getAvailableOptionsData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
    return YearlyScheduleHarmonizationManager.getFirstOrThirdRowSchedule(!isArchive, availableOptions.time);
};
YearlyScheduleHarmonizationManager.getFieldDayOfWeekOptionsData = (isArchive, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue) => {
    const availableOptions = YearlyScheduleHarmonizationManager.getAvailableOptionsData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue);
    return YearlyScheduleHarmonizationManager.getFirstOrThirdRowSchedule(!isArchive, availableOptions.dayOfWeek);
};
YearlyScheduleHarmonizationManager.getAvailableOptionsData = (dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue) => {
    const monthlyAvailableOptions = MonthlyScheduleHarmonizationManager_1.MonthlyScheduleHarmonizationManager.getAvailableOptionsData(dailyScheduleModelValue, weeklyScheduleModelValue);
    const monthlyCurrentState = MonthlyScheduleHarmonizationManager_1.MonthlyScheduleHarmonizationManager.getCurrentStateData(monthlyScheduleModelValue);
    return {
        time: {
            firstRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('firstRow', monthlyCurrentState.time, monthlyAvailableOptions.time),
            secondRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('secondRow', monthlyCurrentState.time, monthlyAvailableOptions.time),
            thirdRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('secondRow', monthlyCurrentState.time, monthlyAvailableOptions.time),
        },
        dayOfWeek: {
            firstRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('firstRow', monthlyCurrentState.dayOfWeek, monthlyAvailableOptions.dayOfWeek),
            secondRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('secondRow', monthlyCurrentState.dayOfWeek, monthlyAvailableOptions.dayOfWeek),
            thirdRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('thirdRow', monthlyCurrentState.dayOfWeek, monthlyAvailableOptions.dayOfWeek),
        },
        monthOfYear: {
            firstRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('firstRow', monthlyCurrentState.monthOfYear, monthlyAvailableOptions.monthOfYear),
            secondRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('secondRow', monthlyCurrentState.monthOfYear, monthlyAvailableOptions.monthOfYear),
            thirdRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('thirdRow', monthlyCurrentState.monthOfYear, monthlyAvailableOptions.monthOfYear),
        },
        dayNumberInMonth: {
            firstRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('firstRow', monthlyCurrentState.dayNumberInMonth, monthlyAvailableOptions.dayNumberInMonth),
            secondRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('secondRow', monthlyCurrentState.dayNumberInMonth, monthlyAvailableOptions.dayNumberInMonth),
            thirdRow: YearlyScheduleHarmonizationManager.getAvailableOptionsRow('thirdRow', monthlyCurrentState.dayNumberInMonth, monthlyAvailableOptions.dayNumberInMonth),
        },
    };
};
//# sourceMappingURL=YearlyScheduleHarmonizationManager.js.map